// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2YyoT","col":"Table_col__wFf44","fulfillmentStatus":"Table_fulfillmentStatus__j1CE-","emailCol":"Table_emailCol__2SxWC"};